export default function CompanyHeader() {
  return (
    <div className="container-x section min-w-0">
      <div className="mx-auto max-w-3xl text-center">
        <p className="eyebrow">About MyOrgLab</p>
        <h1 className="mt-3 font-display text-4xl font-semibold tracking-tight text-ink-900 sm:text-5xl">
          We exist to close the context gap between enterprise data and enterprise decisions.
        </h1>
        <p className="mt-5 text-lg leading-relaxed text-ink-600">
          MyOrgLab builds the semantic foundation for Snowflake-powered Enterprise AI, helping organizations
          modernize BI, migrate analytics to Snowflake, and deliver conversational, governed analytics experiences.
        </p>
        <div className="mt-8 flex w-full min-w-0 flex-col items-stretch justify-center gap-3 sm:flex-row sm:flex-wrap sm:items-center">
          <a href="/contact" className="btn-primary btn-lg">Start a Semantic Readiness Conversation</a>
          <a href="/platform-engineering" className="btn-secondary btn-lg">Explore Semantic Platform Engineering</a>
        </div>
      </div>
    </div>
  );
}
